"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var icons_1 = require("@tiendanube/icons");
var Thumbnail_1 = __importDefault(require("./Thumbnail"));
require("./Thumbnail.css");
function Select(_a) {
    var src = _a.src, altText = _a.altText, aspectRatio = _a.aspectRatio, width = _a.width, selected = _a.selected, id = _a.id, onSelect = _a.onSelect;
    var handleOnChange = function () { return onSelect(id); };
    return (React.createElement(Thumbnail_1.default, { aspectRatio: aspectRatio, width: width, src: src, altText: altText },
        React.createElement("label", { htmlFor: id, className: "nimbus--thumbnail-select-wrapper" },
            React.createElement("input", { onChange: handleOnChange, className: "nimbus--thumbnail-select", id: id, type: "checkbox", checked: selected }),
            React.createElement("div", { className: "nimbus--thumbnail-select__label" },
                React.createElement("div", { className: "nimbus--thumbnail-select__check" },
                    React.createElement(icons_1.CheckIcon, null))))));
}
exports.default = Select;
//# sourceMappingURL=Thumbnail.Select.js.map